export default __webpack_public_path__ + "static/media/Carousel1Login.595d8bea.png";